import * as S from './styles';

export const PoweredByQITech = () => (
    <S.Container href="https://qitech.com.br/" target="_blank" rel="noopener noreferrer">
        <img src="/assets/logo192.png" width={18} height={18} alt="QI Tech" />
        <S.PoweredBy>Powered by</S.PoweredBy>
        <S.Brand>QI Tech</S.Brand>
    </S.Container>
);
